<template>
    <div>
        <div class="field is-expanded">
            <div class="field has-addons">
                <p class="control">
                    <a class="button is-static">http://</a>
                </p>
                <div class="control is-expanded">
                    <input
                        v-validate="{
                            regex: /(\?v=([^#\&\?]{11}))|(youtu\.be\/([^#\&\?]{11})|(\&v=([^#\&\?]{11}))|(embed\/([^#\&\?]{11}))|(\/v\/([^#\&\?]{11})))/,
                        }"
                        :value="urlInput"
                        class="input"
                        type="text"
                        placeholder="Video"
                        name="video"
                        @input="$emit('input', $event.target.value)"
                    />
                </div>
                <p class="control">
                    <button
                        v-t="'creation.preview'"
                        :class="{ 'is-static': errors.has('video') }"
                        class="button is-outlined is-link"
                        @click="loadPreview"
                    />
                </p>
            </div>
            <p v-if="errors.has('video')" class="help is-danger">
                {{ errors.first('video') }}
            </p>
        </div>
        <span v-if="loading" class="file-icon">
            <i class="fas fa-circle-notch fa-pulse" />
        </span>
        <div class="level">
            <div class="level-item">
                <youtube
                    v-if="videoId && !errors.has('video')"
                    ref="youtube"
                    :video-id="videoId"
                    :fit-parent="true"
                    :resize="true"
                    :resize-delay="500"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputVideo',
    components: {},
    model: {
        prop: 'video',
    },
    props: {
        video: { type: String, default: undefined },
    },
    data() {
        return {
            videoId: undefined,
            loading: false,
        };
    },
    computed: {
        urlInput() {
            return this.extractProtocol(this.video);
        },
    },
    watch: {
        video: {
            handler: async function (newVal) {
                this.videoInput = newVal;
            },
            immediate: true,
        },
    },
    methods: {
        async loadPreview() {
            this.loading = true;
            this.videoId = this.$youtube.getIdFromUrl(this.videoInput);
            this.loading = false;
        },
        extractProtocol(url) {
            if (!url) {
                return;
            }
            let hostname;
            //find & remove protocol (http, ftp, etc.) and get hostname
            if (url.indexOf('//') > -1) {
                const splittedUrl = url.split('/');
                hostname = splittedUrl.slice(2, splittedUrl.length).join('/');
            }
            return hostname;
        },
    },
};
</script>

<style scoped>
iframe {
    height: 360px;
    width: 100%;
    max-width: 650px; /* Also helpful. Optional. */
}
</style>
